import Logo from '../../../assets/logo_header.svg'
import './HomeWrapper.css'
import {Footer} from "../../footer/Footer";
import Banner from '../../../assets/model_banner.png'
import AISC from '../../../assets/aisc.png'
import NISD from '../../../assets/nisd.png'
import {Link} from "react-router-dom";


export const HomeWrapper = () => {
    return (
        <div className="App">
            <nav className="top-menu">
                <div className="logo-wrapper">
                    <img src={Logo}/>
                </div>
                <div className="expand"></div>
                <div className="menu-items">
                    <Link to="" className="menu-item">Home</Link>
                    <Link to="company" className="menu-item">Company</Link>
                    <Link to="/mission" className="menu-item">Mission</Link>
                    <Link to="/services" className="menu-item">Services</Link>
                    <a className="menu-item" href="#">Projects</a>
                    <Link to="/contact-us" className="menu-item menu-item-accent">Get a Quote</Link>
                </div>
            </nav>
            <div className="main-container home-container">
                <div className="banner-wrapper">
                    <img src={Banner}/>
                </div>
                <div className="banner-texts-wrapper">
                    <div className="banner-main-text-wrapper">
                        <h1>Rocky Point Detailing, LLC <br/>
                            & Aircad, LLC</h1>
                        <p className="banner-text">
                            Are a structural steel and miscellaneous metals detailing firm having <br/>
                            provided quality accurate shop drawings to steel fabricators since 1993.
                        </p>
                    </div>
                    <div className="memberships-wrapper">
                        <h1>Memberships</h1>
                        <div className="memberships-logos-wrapper">
                            <div>
                                <img src={AISC}/>
                            </div>
                            <div className="memrbership-logo memrbership-logo-nisd">
                                <img src={NISD}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer/>
        </div>
    )
}